export const AGRICULTURAL_OPPORTUNITY ="Agricultural Opportunity";
export const ANNUAL_KEY_STRATEGIC ="Annual/ Key/ Strategic";
export const EQUIPMENTONE_OPPORTUNITY ="EquipmentOne Opportunity";
export const EXHIBITA_OPPORTUNITY ="Exhibit A Opportunity";
export const FIXED_OPPORTUNITY ="Fixed Assets";
export const INDUSTRIAL_OPPORTUNITY ="Industrial Opportunity";
export const INTERCOMPANY_OPPORTUNITY ="Inter-Company Assets";
export const INVENTORY_OPPORTUNITY ="Inventory Assets";
export const IRONPLANET_OPPORTUNITY ="IronPlanet Opportunity";
export const MULTICHANNEL_OPPORTUNITY ="Multi-Channel Opportunity";
export const MULTICHANNEL_OPPORTUNITY_OLD ="Multi-Channel Opportunity Old";
export const PAID_APPRAISAL_OPPORTUNITY ="Paid Appraisal Opportunity";
export const SUSPENSE_OPPORTUNITY ="Suspense Assets";
export const PLACEHOLDER_OPPORTUNITY ="Placeholder";
export const NON_MARS_OPPORTUNITY ="Non-MARS Opportunity";
export const CONSIGNMENT_OPPORTUNITY = "Consignment Opportunity";
